
<template>
  <div>
    <Multiselect
      v-model="selectedTimeUnit"
      :options="options"
      class="timeCat"
      placeholder="TIME UNITS"
    ></Multiselect>
  </div>
</template>
<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss" scoped>
div {
  width: 160px;
}
.timeCat {
  font-family: Play-Bold;
  color: $white;
  margin: 50px 0px 0px 0px;
  --ms-font-size: 14px;
  --ms-radius: 30px;
  --ms-border-color: $white;
  --ms-bg: linear-gradient(#ff6538, #a83d1d);
  --ms-dropdown-bg: rgb(245, 197, 182);
  --ms-placeholder-color: #ffffff;
}

</style>

<script>
import Multiselect from "@vueform/multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedTimeUnit: "MINUTES",
      options: ["SECONDS", "MINUTES", "HOURS", "DAYS"],
    };
  },
  watch: {
    selectedTimeUnit: function () {
      if (this.selectedTimeUnit === null) {this.selectedTimeUnit='MINUTES'}
      this.$store.commit("setTimeUnits", { units: this.selectedTimeUnit });
      this.$store.commit("resetTimer");
    },
  },
  mounted(){
      this.selectedTimeUnit=this.$store.getters.getTimeUnits;
    }
};
</script>